import { Component, Input } from '@angular/core';
import { Representative } from 'src/app/core/interfaces/shared.interface';

@Component({
  selector: 'app-detail-view-representatives',
  templateUrl: './detail-view-representatives.component.html'
})
export class DetailViewRepresentativesComponent {
  @Input() representatives: Representative[];
}
